module.exports = __webpack_public_path__ + "static/media/future-building.d48ffb7b.md";